import './App.css';
import MintNft from './components/MintNft'


function App() {
  return (
    <div className="App">
      <MintNft />
    </div>
  );
}

export default App;
